import { defineComponent as _defineComponent } from 'vue'
import { packsCatalogResource } from '@/services/packs.service'
import { prefixLanguage } from '@/utils/urls'


export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog',
  props: {
  initial: {
    type: Object,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const urlPath = prefixLanguage('festival-packs')

const __returned__ = { props, urlPath, get packsCatalogResource() { return packsCatalogResource }, get prefixLanguage() { return prefixLanguage } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})